var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container", attrs: { id: "goods-edit" } }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("矩阵管理")]),
            ]),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { path: "/goodsList" } } },
              [_c("div", { staticClass: "div2" }, [_vm._v("佣金管理")])]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("平台佣金")]),
      _c("div", { staticClass: "line" }),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "padding-top": "24px",
            "padding-bottom": "24px",
          },
        },
        _vm._l(_vm.prices, function (item, index) {
          return _c("div", { key: index, staticClass: "item-t" }, [
            _c("div", { staticClass: "title" }, [_vm._v(_vm._s(item.title))]),
            _c("div", { staticClass: "price" }, [_vm._v(_vm._s(item.price))]),
          ])
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "content" }, [
      _c("h3", [_vm._v("数据筛选")]),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              attrs: { inline: true, model: _vm.searchForm, size: "small" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "下单用户", prop: "userInfo" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入下单用户信息", clearable: "" },
                    model: {
                      value: _vm.searchForm.userInfo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "userInfo", $$v)
                      },
                      expression: "searchForm.userInfo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "订单编号", prop: "orderNo" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入订单编号", clearable: "" },
                    model: {
                      value: _vm.searchForm.orderNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "orderNo", $$v)
                      },
                      expression: "searchForm.orderNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "订单时间", prop: "brandId" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "250px" },
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "default-time": ["00:00:00", "23:59:59"],
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.orderTime,
                      callback: function ($$v) {
                        _vm.orderTime = $$v
                      },
                      expression: "orderTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "settlementStatus" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择状态",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.searchForm.settlementStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "settlementStatus", $$v)
                        },
                        expression: "searchForm.settlementStatus",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "未到账", value: "1" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已到账", value: "2" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "margin-top": "4px" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "btn-search",
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "btn-search",
                        staticStyle: { "margin-left": "20px" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v(" 重置 ")]
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "title" }, [
        _c("h3", [_vm._v("列表数据")]),
        _c("div", { staticClass: "derive", on: { click: _vm.deriveDeliver } }, [
          _vm._v("导出"),
        ]),
      ]),
      _c(
        "div",
        { attrs: { id: "base-list" } },
        [
          _c("lb-table", {
            directives: [
              {
                name: "horizontal-scroll",
                rawName: "v-horizontal-scroll",
                value: "always",
                expression: "'always'",
              },
            ],
            attrs: {
              column: _vm.columns,
              data: _vm.page.list,
              pagination: "",
              total: _vm.page.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page.currentPage,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "selection-change": _vm.onMultipleSelection,
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }